import { useCallback, useEffect, useState } from "react";
import { SimpleHttp } from "src/lib/utils/SimpleHTTP";


export default function useGetStacks() {
  const [stacks, setStacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const [retryCount, setRetry] = useState(0);

  const retry = () => {
    setRetry((prev) => ++prev);
  };

  const fetchData = useCallback(
    async () => {
      try {
        const { status, data, error } = await SimpleHttp.getNoAuth(
          `/api/v1/comp/getStacks`
        );
        if (status === true) {
          setStacks(data);
        } else {
          // toast.error(error?.message)
          console.log("Stacks Error:", error);
        }
      } catch (error) {
        console.log("Stacks Error:", error);
        setError(error);
      }
    
      setLoading(false);
    },
    [],
  )

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [retryCount]);

  return { stacks, loading, error, retry };
}
